import * as React from 'react';

import { Toolbar, Typography, Paper, Table, TableBody, TableRow } from '@mui/material';
import { CustomTableCellText } from './material-ui-styles';

import { AgendaHistoryAudit } from '../../../../store/details/agenda/model';
import { Ii18n } from '../../../../store/utils/contracts/i18n.interface';
import { getI18n } from '../../../../store/utils/i18n/strings.manager';
import styles from './agenda.module.css';

interface Props {
  readonly title: string;
  readonly rows: AgendaHistoryAudit[];
  readonly selectedHistoryId: number | null;
  readonly currentLanguage: string;
  readonly useAgendaFromHistory: (agendaHistoryAuditId: number) => void;
}

type AllProps = Props;

export class AgendaHistoryTable extends React.Component<AllProps> {
  private localization: Ii18n;

  constructor(props: AllProps) {
    super(props);
    this.localization = getI18n();
  }

  render() {
    return (
      <div>
      <Paper className={styles.agendaHistoryTitle}>
        <Toolbar className={styles.toolbar}>
          <Typography variant='h5' id='tableTitle'>
            {this.props.title}
          </Typography>
        </Toolbar>
        </Paper>
        <Paper className={styles.agendaHistoryContainer}>
        <Table className={styles.table}>
          <TableBody className={styles.tableBody}>
            {this.props.rows.map(row => {
              return (
                <TableRow hover
                  className={this.props.selectedHistoryId === row.agendaHistoryAuditId ? styles.selectedHistoryLine : styles.historyLine}
                  key={row.agendaHistoryAuditId}
                  onClick={() => {
                      this.props.useAgendaFromHistory(row.agendaHistoryAuditId);
                  }}
                >
                  <CustomTableCellText component='th' scope='row'>
                    {row.agendaReference ? row.agendaReference : ''}
                  </CustomTableCellText>
                  <CustomTableCellText component='th' scope='row'>
                    <span className={styles.singleLine}>
                      {row.plannedOnDate ? this.localization.getFormatedDateTime(row.plannedOnDate, this.props.currentLanguage) : ''}
                    </span>
                  </CustomTableCellText>
                  <CustomTableCellText component='th' scope='row'>
                    {row.status ? row.status : ''}
                  </CustomTableCellText>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Paper>
      </div>
    );
  }
}
